<template>
  <ul id="hoverComponentsForIndex">
    <li class="hang">
      <h4>蜜蜂停车介绍</h4>
      <p>
        蜜蜂停车，是亿车旗下的互联网停车子品牌，专注于封闭式停车场的收费结算与运营管理，经过多年的自主研发创新，软硬件产品不断迭代完善，凭借雄厚的技术沉淀和丰富的经验积累，已成为国内领先的知名互联网停车服务平台。
      </p>
    </li>
    <router-link v-for="item in list" :key="item.name" :to="{ path: item.path }" target="_blank">
      <li :class="(item.path).split('/').pop()">
        <h4 class="cur">{{ item.name }}</h4>
        <div>
          <!-- <img :src="item.img">
          <span>{{item.content}}</span> -->
        </div>
      </li>
    </router-link>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          name: '联网升级(蜜蜂停车)',
          path: '/parkbees',
          content: '',
          img: require('./images/mifengtingche_.jpg'),
        },
        {
          name: '停车经营(九宫格)',
          path: '/parking',
          content: '',
          img: require('./images/jiugongge_.jpg'),
        },
        {
          name: '城市合伙人(星云联盟)',
          path: '/citypartner',
          content: '',
          img: require('./images/xingyunlianmeng_.jpg'),
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss">
@import '../variable.scss';

#hoverComponentsForIndex {
  display: flex;
  display: -ms-flexbox;
  color: #000;
  padding: 40px 0;
  .hang {
    margin-right: 48px;
  }

  li {
    font-size: 14px;
    line-height: 14px;
    margin-right: 24px;
    display: inline-block;
    cursor: pointer;
    &:first-child {
      cursor: auto;
    }
    &:last-child {
      padding-right: 0;
    }
    h4 {
      margin-bottom: 25px;
      color: #0f2347;
    }
    p {
      width: 220px;
      line-height: 1.6;
      font-size: 14px;
      color: #000000;
      opacity: 0.88;
    }
    div {
      position: relative;
      img {
        width: 276px;
        height: 152px;
        cursor: pointer;
      }
      span {
        color: #ffffff;
        position: absolute;
        left: 20px;
        bottom: 20px;
      }
    }
  }

  .parkbees {
    > div {
      width: 276px;
      height: 176px;
      cursor: pointer;
      background: url('./images/mifengtingche_.jpg') no-repeat;
      background-size: 100% 100%;
    }
    div:hover {
      background: url('./images/mifengtingche__.jpg') no-repeat;
      // transform: translateZ(-50px) rotateX(95deg);
    }
  }
  .parking {
    > div {
      width: 276px;
      height: 176px;
      cursor: pointer;
      background: url('./images/jiugongge_.jpg') no-repeat;
      background-size: 100% 100%;
    }

    div:hover {
      background: url('./images/jiugongge__.png') no-repeat;
    }
  }
  .citypartner {
    > div {
      width: 276px;
      height: 176px;
      cursor: pointer;
      background: url('./images/xingyunlianmeng_.jpg') no-repeat;
      background-size: 100% 100%;
    }

    div:hover {
      background: url('./images/xingyunlianmeng__.png') no-repeat;
    }
  }

  a {
    color: #000000;
    text-decoration: none;
  }
  span {
    cursor: pointer;
  }
  span:hover {
    font-weight: bold;
  }
  .cur {
    cursor: pointer;
    color: #0f2347;
  }
}
</style>
